module.exports = __webpack_public_path__ + "img/trash-mdi.2dfb015d.svg";